import React from 'react';
var DividerHtmlRenderer = function () {
    return React.createElement("hr", { className: "react-page-plugins-content-divider" });
};
export default DividerHtmlRenderer;
//# sourceMappingURL=DividerHtmlRenderer.js.map